"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var config_1 = require("./config");
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var Tab_1 = __importDefault(require("./Tab"));
var Tabs = function (_a) {
    var onClickHandler = _a.onClickHandler, activeTab = _a.activeTab, isFinished = _a.isFinished;
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.container }, (isFinished
        ? config_1.tabs.filter(function (t) { return t.slug !== 'tournamentPrizes'; })
        : config_1.tabs).map(function (tab, idx) { return (react_1.default.createElement(Tab_1.default, { key: tab.slug + idx, tab: tab, onClickHandler: function () { return onClickHandler(tab.index); }, isActiveTab: activeTab === idx })); })));
};
exports.default = Tabs;
